import { RESET_STATE } from 'store/global/actions';

import { LOAN_OPTION_TYPE } from '../actions';

const initialState = {};

const loanOptionReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_OPTION_TYPE.GET_LOAN_OPTION_CONFIGURATION:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanOptionReducer;
